import React, { PureComponent } from 'react';
import injectSheet from 'react-jss';
import { Bar, HorizontalBar } from 'react-chartjs-2';
import { Card, Spin, Typography, Button, Row, Col } from 'antd';
import { FormattedMessage } from 'react-intl';
import numberWithSpaces from 'src/utils';
import moment from 'moment';
import styles from './styles';
const { Title, Text } = Typography;
const data = {
	labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
	datasets: [
		{
			label: 'My First dataset',
			backgroundColor: 'rgba(255,99,132,0.2)',
			borderColor: 'rgba(255,99,132,1)',
			borderWidth: 1,
			hoverBackgroundColor: 'rgba(255,99,132,0.4)',
			hoverBorderColor: 'rgba(255,99,132,1)',
			data: [65, 59, 80, 81, 56, 55, 40]
		}
	]
};

import { getTopIncomeRestaurant } from 'src/redux/actions/dashborad';

//redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

function mapStateToProps(state) {
	return {
		store: {
			incomeRestaurant: state.dashboard.incomeRestaurant
		}
	};
}

const mapDispatchToProps = dispatch => {
	return {
		action: bindActionCreators(
			{
				// getListCreditDetails
				getTopIncomeRestaurant
			},
			dispatch
		)
	};
};

@injectSheet(styles)
@connect(
	mapStateToProps,
	mapDispatchToProps
)
export default class CharRetaurant extends PureComponent {
	state = {
		loading: true,
		setLimit: 0, // Limit par defaut
		defaultLimit: 10, // nb données à affiché 
		displayBtn: false, // afficher boutton 
		disabledBtn: false, // Désactivé boutton
		setBackgroundColor: [ // couleur des barres du graphique
			"rgba(255,158,13,0.5)", "rgba(133,133,133,0.5)", "rgba(1,173,125,0.5)"
		],
		setColorBtn: "#FF9E0D", // couleur bouton orange
		xAxesMaxValue: [],
	};

	filter = {
		limit: 1,
		month: 8,
		year: 2019
	};

	componentDidMount() {
		const filter = this.filter;
		this.handelGetTopAffectRestaurant(filter);

	}

	handelGetTopAffectRestaurant = filter => {
		const payload = {
			// limit: 5
		};
		this.setState({ loading: true });
		this.props.action.getTopIncomeRestaurant(
			payload,
			() => {
				this.setState({ loading: false });
			},
			() => {
				this.setState({ loading: false });
			}
		);
	};

	convertDataForChart = data => {
		let outPut = {
			labels: [],
			datasets: [
				{
					label: 'Restaurant',
					backgroundColor: this.state.setBackgroundColor,
					data: [],
				}
			]
		};
		if (data.length > 0) {
			data.map(e => {
				if (typeof e.restaurantName === 'string' && e.restaurantName.length > 12) {
					// outPut.labels.push(`${e.restaurantName.slice(0, 25)}...`);
					outPut.labels.push(
						{
							label: `${e.restaurantName.slice(0, 15)}...`,
							total: e.sum_amount
						}
					)
				} else {
					// outPut.labels.push(e.restaurantName);
					outPut.labels.push(
						{
							label: e.restaurantName,
							total: e.sum_amount
						}
					)
				}
				outPut.datasets[0].label = `${e.month}/${e.year}`;
				outPut.datasets[0].data.push(parseInt(e.sum_amount, 10));
				this.state.xAxesMaxValue.length = 1;
				this.state.xAxesMaxValue.push(Math.max(outPut.labels[0].total))

				// this.setState({xAxesMaxValue: Math.max(outPut.labels[0].total)})
			});

		}
		return outPut;
	};

	// set slice data for chart by limit
	dataChartLimit = (setLimit) => {
		const {
			classes,
			store: {
				incomeRestaurant: { data = [] }
			}
		} = this.props;

		const limitRange = []; // set range limit 
		const valueRange = Math.trunc(data.length / this.state.defaultLimit) + 1; // get number range
		let varLimit = 0
		// (setLimit <= data.length) ?  limitRange.push(5*limitRange.length) : ''

		// set value of range
		for (let i = 0; i < valueRange; i++) {
			limitRange.push(this.state.defaultLimit * i)
		}

		// compare value limit & value of range
		limitRange.forEach(element => {
			if (setLimit == element) {
				return varLimit = element
			}
		});

		if (Math.sign(data.length - (this.state.setLimit + this.state.defaultLimit)) == -1 || Math.sign(data.length - (this.state.setLimit + this.state.defaultLimit)) == 0) {
			return this.setState({ disabledBtn: true, setColorBtn: '' }), (setLimit == varLimit) ? data.slice(setLimit, setLimit + this.state.defaultLimit) : data.slice(0, setLimit)
		}
		else {
			return this.setState({ disabledBtn: false, setColorBtn: '#FF9E0D' }), (setLimit == varLimit) ? data.slice(setLimit, setLimit + this.state.defaultLimit) : data.slice(0, setLimit)
		}
	}

	// reset data chart by default
	setDefaultDataChart = () => {
		const {
			classes,
			store: {
				incomeRestaurant: { data = [] }
			}
		} = this.props;

		// set color bar by element
		data.forEach(element => {
			this.state.setBackgroundColor.push("rgba(255,158,13,0.5)", "rgba(133,133,133,0.5)", "rgba(1,173,125,0.5)")
		});

		// display button 'Afficher moins'
		return (this.state.displayBtn == true && data.length > this.state.defaultLimit)
			?
			<>
				< Button
					icon="minus"
					style={{ color: 'red' }}
					type='link'

					onClick={() => this.setState({ setLimit: 0, displayBtn: false })}
				>
					Afficher moins
				</Button >
			</>
			:
			<></>
	}

	render() {
		const {
			classes,
			store: {
				incomeRestaurant: { data = [] }
			}
		} = this.props;

		const { loading } = this.state;
		const limitChart = this.state.setLimit		// get data chart limit
		const dataChart = this.convertDataForChart(data);

		const options = {
			legend: {
				display: false,
			},
			scales: {
				yAxes: [
					{
						gridLines: {
							display: true,
						},
						ticks: {
							beginAtZero: true,
							fontSize: 15,
							callback(value) {
								// you can add your own method here (just an example)
								// return Number(value).toLocaleString('en-US');
								return numberWithSpaces(value.label);
							}
						}
					},
					{
						type: 'category',
						position: 'right',
						ticks: {
							fontSize: 15,
							callback(value) {
								// you can add your own method here (just an example)
								// return Number(value).toLocaleString('en-US');
								return numberWithSpaces(value.total);
							}
						},
						offset: true,
						gridLines: {
							display: false
						},
					}
				],
				xAxes: [
					{
						// display: false,
						gridLines: {
							display: true,
							// color: "rgba(0, 0, 0, 0)",
						},
						ticks: {
							// display: false,
							fontSize: 0,
							// max: this.state.xAxesMaxValue,
							callback(value) {

								// you can add your own method here (just an example)
								// return Number(value).toLocaleString('en-US');
								// return numberWithSpaces(value);
								return value
							}
						}
					}
				],
			},
			tooltips: {
				enabled: false,
				callbacks: {
					label: function (tooltipItem, data) {
						var label = data.datasets[tooltipItem.datasetIndex].label || '';
						if (label) {
							label += ': ';
						}
						// label += Number(tooltipItem.yLabel).toLocaleString('en');
						label += "" + numberWithSpaces(tooltipItem.xLabel) + " XPF ";
						return label;
					},

				},

			},
		};

		return (
			<Spin spinning={loading}>
				<Card bordered={true}>
					<Title type="secondary" level={4}>
						{'Répartition des dépenses par établissements' + ' (' + moment(new Date(), 'DD/MM/YYYY').format('MM-YYYY') + ') :'}
					</Title>
					<HorizontalBar
						data={this.convertDataForChart(this.dataChartLimit(limitChart))}
						// width={350}
						// height={200}
						options={{
							...options,
						}}
					/>
					<Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
						<Col className="gutter-row" span={5}>
							<Button
								icon="plus"
								type='link'
								style={{ color: this.state.setColorBtn }}
								disabled={this.state.disabledBtn}
								onClick={() => {
									return this.setState({ setLimit: limitChart + this.state.defaultLimit, displayBtn: true })
								}}
							>
								Afficher plus
							</Button>
						</Col>
						<Col className="gutter-row" span={5}>{this.setDefaultDataChart()}</Col>
					</Row>
					<Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
						<Col justify='end' className="gutter-row" span={24} style={{ textAlign: 'right', color: 'grey', fontWeight: 'bold' }}>
							<div style={{ justifyContent: 'right' }}>Total: <span style={{ color: '#FF9E0D' }}>{data.length} établissements </span></div>
						</Col>
					</Row>
				</Card>
			</Spin>
		);
	}
}
